import React from 'react';
import { ModalBackdrop } from './modal-backdrop';
import PhoneBlueIcon from '../../assets/images/svgs/phone-blue-26.svg';

// Close icon component
const CloseIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={`text-label-gray ${className ?? ''}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

interface HowCallWorksModalProps {
  open: boolean;
  onClose: () => void;
}

export const HowCallWorksModal: React.FC<HowCallWorksModalProps> = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <>
      <ModalBackdrop onExit={onClose} />
      <div className="fixed bottom-0 left-0 right-0 z-40 max-h-[90vh] max-w-[707px] overflow-y-auto rounded-t-[15px] bg-white sm:left-1/2 sm:top-1/2 sm:max-h-[max-content] sm:-translate-x-1/2 sm:-translate-y-1/2 sm:rounded-xl">
        <div className="flex flex-col gap-6 p-6">
          {/* Header */}
          <div className="border-input-border-gray flex items-center justify-between border-b pb-5 pt-0">
            <div className="flex items-center gap-2">
              <div className="flex h-[22px] w-[22px] shrink-0 items-center justify-center">
                <img src={PhoneBlueIcon} alt="Phone" className="h-[22px] w-[22px]" />
              </div>
              <p className="font-albert-sans text-label-gray text-xl font-medium leading-7">How a call works</p>
            </div>
            <button
              onClick={onClose}
              className="flex h-9 w-9 items-center justify-center rounded-full bg-gray-50"
              data-testid="how-call-works-close-button"
            >
              <CloseIcon className="h-5 w-5" />
            </button>
          </div>

          {/* Body */}
          <div className="flex flex-col gap-0">
            <div className="flex flex-col items-start">
              <div className="w-full">
                <p className="font-albert-sans text-label-gray mb-0 text-base font-medium leading-5">
                  When it's time for your scheduled call, you can choose to dial in a few minutes early to get
                  comfortable, or simply wait and we'll call you at your scheduled time.
                </p>
                <p className="mb-0">&nbsp;</p>
                <p className="font-albert-sans text-label-gray mb-0 text-base font-medium leading-5">
                  For your privacy and peace of mind, all phone numbers are kept anonymous. You'll see our system number
                  rather than your Listener's, and they won't see yours.
                </p>
                <p className="mb-0">&nbsp;</p>
                <p className="font-albert-sans text-label-gray mb-0 text-base font-medium leading-5">
                  Once you're connected, there's nothing you need to prepare or explain upfront. Take a breath, settle
                  in, and let your Peer Listener create a calm, supportive space where you can share whatever feels
                  right for you.
                </p>
                <p>&nbsp;</p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="border-input-border-gray flex items-center justify-end border-t pt-6">
            <button
              onClick={onClose}
              className="font-albert-sans bg-button-primary hover:bg-button-primary-hover flex items-center justify-center gap-1.5 rounded-full px-7 py-2.5 text-base font-medium leading-5 text-white shadow-[0px_1px_0.5px_0.05px_rgba(29,41,61,0.02)] transition-colors"
              data-testid="how-call-works-close-button-footer"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
